import * as React from 'react';
import './RedirectToSignin.scss';
import Alert from '../ForgotPasswordView/components/Alert';
import { goToLogin } from 'src/utils/navigation';

interface IRedirectToSigninProps {
  signout(): void;
}

export class RedirectToSignin extends React.Component<
  IRedirectToSigninProps,
  any
> {
  public componentDidMount() {
    this.props.signout();
    // Do redirect
    setTimeout(() => {
      goToLogin();
    }, 5000);
  }
  public render() {
    return (
      <div className="rp-redirecttosignin">
        <div className="rp-redirecttosignin--container">
          <div className="rp-redirecttosignin--container--alert">
            <Alert
              type="success"
              children={
                <span>
                  <b>Password successfully</b> updated. You will be redirected
                  to the sign in page.
                </span>
              }
              icon="rpds-check-circle"
            />
          </div>
          <div className="rp-redirecttosignin--container--content">
            <div className="rp-redirecttosignin--container--container">
              <h1>Redirecting you to Sign In...</h1>
              <p className="rp-redirecttosignin--container--p">
                As a security measure we will take you back to Sign In so you
                can enter with your new password!
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
